import { createContext } from 'react';

const ScrollElementContext = createContext({});
ScrollElementContext.displayName = 'ScrollElementContext';
export default ScrollElementContext;
